import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers, faClipboard, faCalendar } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css'

library.add(faUsers, faClipboard, faCalendar)

const divStyle = {
  backgroundColor: '#d9d9d9',
  border: '2px solid #666666',
  height: '300px',
  float: 'left',
  borderRadius: '15px',
  marginRight: '30px',
  textAlign: 'center',
  color: 'black',
}

const innerDivStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  height: '30%',
  width: '50%',
  margin: '-15% 0 0 -25%',
}

const iconStyle = {
  fontSize: '80px',
}

const Tool = props => <a href={props.link} target={props.target} style={divStyle} className="col-xs-10 col-md-3 col-sm-3 justify-content-center"><div><div style={innerDivStyle}><FontAwesomeIcon icon={props.icon} style={iconStyle}></FontAwesomeIcon><p>{props.name}</p></div></div></a>

Tool.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  target: PropTypes.string,
}

export default Tool
